import React, {memo, useEffect, useState} from 'react';
import _ from 'lodash';
import './ContentPreloader.less';

function ContentPreloader({size, inline}) {
  const [showPreloader, setShowPreloader] = useState(inline);

  useEffect(() => {
    const t = setTimeout(() => {
      setShowPreloader(true);
    }, 1000);
    return () => {
      clearTimeout(t);
    };
  }, []);

  if (!showPreloader) {
    return null;
  }

  return (
    <div className={`content-preloader ${inline ? 'inline' : ''}`}>
      <div className="sk-circle-bounce" style={size ? {width: size, height: size} : {}}>
        {
          _.times(12, (index) => (
            <div className={`sk-child sk-circle-${index + 1}`} key={index} />
          ))
        }
      </div>
    </div>
  );
}

export default memo(ContentPreloader);
